export { default as StaticMap } from './static-map';
